// pt-BR of the shared composer (decision D36); complete for every key of en-composer.ts (checked by the type).
import type { enComposer } from "./en-composer.ts";

export const ptBRComposer: Record<keyof typeof enComposer, string> = {
  "composer.attach": "Anexar arquivos",
  "composer.attachHint": "Até 5 arquivos de 10 MB: imagens e capturas de tela (PNG, JPEG, WebP, GIF, BMP, TIFF, AVIF, HEIC, SVG), PDF, Word, Excel, texto, código, Markdown, JSON, CSV ou logs. Também dá para soltar ou colar aqui.",
  "composer.dropHere": "Solte os arquivos para anexá-los",
  "composer.attachments": "Anexos",
  "composer.remove": "Remover {name}",
  "composer.uploading": "Enviando…",
  "composer.uploadFailed": "Falha no envio: {reason}",
  "composer.chipLabel": "{name}, {size}, {type}",
  "composer.kind.text": "Texto",
  "composer.kind.image": "Imagem",
  "composer.kind.pdf": "PDF",
  "composer.reject.type": "{name}: este tipo de arquivo não é aceito.",
  "composer.reject.size": "{name}: maior que 10 MB.",
  "composer.reject.empty": "{name} está vazio.",
  "composer.reject.count": "No máximo {max} arquivos por mensagem.",
  "composer.pastedName": "texto-colado-{n}.txt",
  "composer.pastedNote": "O texto longo que você colou virou o anexo {name}.",
  "composer.attachmentsOnly": "Veja o(s) arquivo(s) anexado(s).",
  "composer.waitUploads": "Aguarde o envio dos anexos terminar.",
  "composer.readAttachments": "Arquivos enviados com a pergunta",

  "composer.mic.start": "Ditar",
  "composer.mic.stop": "Parar o ditado",
  "composer.mic.listening": "Ouvindo… fale, depois revise o texto e envie.",
  "composer.mic.unavailable": "O ditado não está disponível neste navegador.",
  "composer.mic.failed": "O ditado parou: o microfone está indisponível ou a permissão foi negada.",

  "composer.slash.menu": "Comandos",
  "composer.slash.clear": "Começar uma nova conversa",
  "composer.slash.help": "Listar os comandos",
  "composer.slash.status": "Situação do projeto ou do sistema",
  "composer.slash.validate": "Validar a prontidão do projeto",
  "composer.slash.task": "Criar uma tarefa",
  "composer.slash.plan": "Fazer um plano",
  "composer.slash.fix": "Corrigir um problema",
  "composer.slash.publish": "Publicar o projeto",
  "composer.slash.logs": "Falhas recentes e seus logs",
  "composer.slash.guardian": "Situação e incidentes do Guardião do servidor",
  "composer.slash.mcp": "Integrações e ferramentas disponíveis",
  "composer.slash.agent": "Escolher um agente",
  "composer.slash.mode": "Escolher um modo",
  "composer.slash.homeOnly": "Escolha o agente e o modo no chat do Início.",
  "composer.help.title": "Comandos",
  "composer.help.unknown": "Qualquer outro texto começando com / é enviado como mensagem.",
  "composer.panel.close": "Fechar",
  "composer.newConversation": "Nova conversa. A anterior continua no histórico do servidor.",

  "composer.mcp.title": "Integrações e ferramentas",
  "composer.mcp.loading": "Carregando as integrações…",
  "composer.mcp.empty": "Nenhuma integração ativa nesta organização.",
  "composer.mcp.forbidden": "Só mantenedores e administradores da organização podem listar as integrações.",
  "composer.mcp.failed": "Não foi possível carregar as integrações.",
  "composer.mcp.tools": "Ferramentas: {list}",

  "composer.prompt.status": "Qual é a situação atual? Resuma o que está rodando, o que está bloqueado e o que aguarda por mim.",
  "composer.prompt.validate": "Valide a prontidão deste projeto e diga o que está faltando.",
  "composer.prompt.publish": "Publique este projeto.",
  "composer.prompt.logs": "Mostre as falhas recentes e os logs delas.",
  "composer.prompt.guardian": "O que o Guardião do servidor está apontando? Liste os incidentes abertos e as correções propostas.",
  "composer.prompt.task": "Crie uma tarefa: {text}",
  "composer.prompt.plan": "Faça um plano para: {text}",
  "composer.prompt.fix": "Corrija este problema: {text}",
  "composer.prefill.task": "Crie uma tarefa: ",
  "composer.prefill.plan": "Faça um plano para: ",
  "composer.prefill.fix": "Corrija este problema: ",

  "composer.home.controls": "Opções do chat",
  "composer.home.project": "Projeto",
  "composer.home.projectAll": "Todos os projetos",
  "composer.home.projectNew": "Novo projeto…",
  "composer.home.agent": "Agente",
  "composer.home.agentDefault": "Assistente padrão",
  "composer.home.integrations": "Integrações",
  "composer.home.integrationsCount": "Integrações ({n})",
  "composer.home.integrationsHint": "As integrações selecionadas vão como dicas de contexto.",
  "composer.home.mode": "Modo",
  "composer.mode.chat": "Conversar",
  "composer.mode.plan": "Planejar",
  "composer.mode.assisted": "Desenvolvimento assistido",
  "composer.mode.autonomous": "Desenvolvimento livre",
  "composer.modeHint.chat": "Só responde: nada é alterado.",
  "composer.modeHint.plan": "Gera um plano ou PRD e tarefas: nada é executado.",
  "composer.modeHint.assisted": "Toda mudança espera a sua confirmação.",
  "composer.modeHint.autonomous": "As ações automáticas rodam; as sensíveis ainda pedem confirmação.",

  // D36.4
  "composer.kind.document": "Documento",
  "composer.thumbnail": "Prévia de {name}",
  "home.attachFiles": "Anexar PRD, capturas de tela ou arquivos",
  "home.attachFilesHint": "Um documento Markdown, TXT, PDF ou DOCX vira o PRD; imagens e outros arquivos vão para o planejador junto com o pedido.",
  "home.planningWithAttachments": "{n} arquivo(s) anexado(s) foram para o planejador junto com o pedido.",
  "apiError.detail": "Detalhe técnico: {detail}",
  "apiError.cause.attachment_type": "Este tipo de arquivo não é aceito. Anexe imagens (PNG, JPEG, WebP, GIF, BMP, TIFF, AVIF, HEIC, SVG), PDF, arquivos do Word ou do Excel, ou arquivos de texto, código, Markdown, JSON, CSV e logs.",
  "apiError.cause.attachment_content": "O conteúdo do arquivo não corresponde ao tipo dele: ele pode estar corrompido ou renomeado.",
  "apiError.cause.attachment_empty": "O arquivo está vazio.",
  "apiError.cause.attachment_too_large": "O arquivo tem mais de 10 MB.",
  "apiError.cause.attachment_name": "O arquivo não tem nome.",
  "apiError.cause.attachment_not_found": "Um anexo não está mais disponível. Anexe-o de novo.",
  "apiError.cause.attachment_scope": "Um anexo pertence a outro projeto. Anexe-o de novo aqui.",
  "apiError.cause.turn_active": "O assistente ainda está respondendo à pergunta anterior. Aguarde ou interrompa.",
  "apiError.tooLarge": "O arquivo tem mais de 10 MB.",
  "apiError.code.bad_request": "Não foi possível entender o pedido. Confira as informações e tente de novo.",
  "apiError.code.unauthenticated": "Sua sessão expirou. Entre novamente.",
  "apiError.code.mfa_required": "Confirme o código de dois fatores para continuar.",
  "apiError.code.forbidden": "Você não tem permissão para fazer isso.",
  "apiError.code.not_found": "Não encontrado: pode ter sido removido ou você não tem mais acesso.",
  "apiError.code.version_conflict": "Isto foi alterado nesse meio-tempo. Recarregue e tente de novo.",
  "apiError.code.idempotency_conflict": "Este pedido já foi enviado com outro conteúdo. Recarregue e tente de novo.",
  "apiError.code.invalid_requirement": "O pedido tem um requisito inválido.",
  "apiError.code.validation_failed": "Algumas informações são inválidas. Confira e tente de novo.",
  "apiError.code.gate_pending": "Uma etapa obrigatória ainda está pendente.",
  "apiError.code.policy_denied": "Uma política bloqueia esta ação.",
  "apiError.code.rate_limited": "Pedidos demais. Aguarde um pouco e tente de novo.",
  "apiError.code.unavailable": "O serviço está indisponível agora. Tente de novo em instantes.",
  "apiError.code.internal": "Algo deu errado no servidor. Tente de novo; se persistir, informe o id de correlação.",
  "apiError.code.unknown": "O pedido falhou. Tente de novo.",
};
